import clsx from "clsx";
import React from "react";

interface SwitchProps {
	id: string;
	name: string;
	label: string;
	onChange: React.ChangeEventHandler<HTMLInputElement>;
	disabled?: boolean;
	reverse?: boolean;
}

export function Switch({
	id,
	name,
	label,
	onChange,
	disabled,
	reverse,
}: SwitchProps) {
	return (
		<div className={clsx("switch-input", { "reverse-order": reverse })}>
			<input
				id={id}
				type="checkbox"
				name={name}
				onChange={onChange}
				disabled={!!disabled}
			/>
			<label htmlFor={id}>{label}</label>
		</div>
	);
}
